import React, { memo } from "react";

const Notfound: React.FC = memo(() => (
  <div className="flex min-h-screen flex-col items-center justify-center gap-2 bg-gray-100 text-center">
    <h1 className="mb-4 text-9xl font-bold text-primary-900">404</h1>
    <p className="text-3xl font-semibold text-primary-800">
      Ops, algo deu errado
    </p>
    <p className="mb-6 text-lg text-gray-600">
      A página que você está procurando não existe, ela pode ter sido movida ou
      excluída.
    </p>
    <button
      className="rounded-lg bg-primary-700 px-6 py-3 font-bold text-white shadow-md transition-all hover:bg-primary-800"
      onClick={() => (window.location.href = "/")}
    >
      VOLTAR AO INÍCIO
    </button>
  </div>
));

Notfound.displayName = "Notfound";

export default Notfound;
